// extracted by mini-css-extract-plugin
export default {"message":"message___EUorH","alert":"alert___QJpdk","success":"success___sqVzT","warning":"warning___J4WeK","error":"error___LAiTg"};